<template>
  <a-table-f-base
    ref="base"
    :model="model"
    :data="data"
    :loading="loading"
    :sort="sort"
    :pager="pager"
    :filters="filters"
    :searchable="searchable"
    :selectedRows="selectedRows"
    :paramName="defaults.paramName || ''"
    :headRows="headRows"
    :footerHide="footerHide"
    @dblclick="onDblClickRow($event)"
    @click="onClickRow($event)"
    @sort="onSort($event)"
    @change-filter="onInputFilter($event)"
    @scrollEnd="onScrollEnd($event)"
    @checkedAll="setCheckAll($event)"
    @rowContextMenu="$emit('rowContextMenu', $event)"
  >
    <template v-slot:top>
      <slot name="top"> </slot>
    </template>
    <template v-for="el in model" v-slot:[getSlotName(el)]="{ item, row, field }">
      <slot :name="getSlotName(el)" :item="item" :row="row" :field="field" />
    </template>
    <template no-data>
      <slot name="no-data" />
    </template>
    <template v-slot:footer v-if="!footerHide">
      <slot name="footer">
        <div class="f-table-footer" v-if="footer">
          <div class="f-table-row">
            <div style="margin: 6px 6px" v-for="el of footer" :key="el.name">{{ el.title }}: {{ pager[el.name] }}</div>
          </div>
        </div>
        <div v-else class="f-table-footer">
          <div class="f-table-row">
            <div style="margin: 6px 6px">Показано: {{ pager && pager.count }}</div>
          </div>
        </div>
      </slot>
    </template>
  </a-table-f-base>
</template>

<script>
import { getIndexSql } from "../../../mixings";
import lodash from "lodash";

export default {
  mixins: [getIndexSql],
  props: {
    sql: String,
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    model: [Object, Array],
    useQuery: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    selectedRows: {
      type: Array,
      default: () => {
        return [];
      },
    },
    defaults: {
      type: Object,
      default: () => {
        return {};
      },
    },
    footerHide: {
      type: Boolean,
      default: false,
    },
    headRows: { type: Number, default: 1 },
  },
  data() {
    return {
      urlPrefix: "q",
      footer: null,
    };
  },
  watch: {
    $route() {
      this.updateData();
    },
    query(v) {
      if (v) this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    getSlotName(model) {
      return `item.` + model.name;
    },
    setCheckAll(v) {
      for (const el of this.data) {
        if (this.model?.check?.isDisableFunc) {
          let res = this.model.check.isDisableFunc(el);
          el.check_disable = res ? 0 : 1;
        }
        if (el?.check_disable) el.checked = 0;
        else el.checked = v;
      }
    },
    onClickRow(event) {
      if (event.field.type === "folder" && event.row.isparent) {
        //  this.filters.parent_id = event.row.id;
        //  this.onChangeFilter();
      }
      if (event.field.type === "checkbox") {
        return;
      }
      if (event.event.button == 0) this.$emit("click", event);
    },
    onDblClickRow(event) {
      if (event.event.button == 0) this.$emit("dblclick", event);
    },
    init() {
      this.date = [];
      if (this.defaults.sessionFilters) this.filters = this.defaults.sessionFilters;
      else if (this.defaults.filters) {
        this.filters = this.defaults.filters;
      } else this.filters = {};
      if (this.defaults.sort) this.sort = this.defaults.sort;
      else this.sort = [{ key: "id", order: "ASC" }];
      this.reloadData();
    },
    reloadData() {
      this.updateData();
    },
    updateData() {
      if (this.useQuery && this.$route.query[this.urlPrefix]) {
        let params = JSON.parse(this.$route.query[this.urlPrefix]);
        if (params.sort) {
          this.sort = params.sort;
        }
        if (params.filters) {
          this.filters = params.filters;
        }
      }
      this.pager.page = 0;
      this.$emit("update-data", this);
      this.fetchData();
    },

    onSort: function (el) {
      console.log("onSort", this.sort, el);
      this.pager.page = 0;
      if (Array.isArray(this.sort)) {
        let idx = this.sort.findIndex((el) => !el?.default);
        let def = this.sort.filter((el) => el?.default === true);
        let order = "ASC";
        let key = el;
        let sort = {};
        if (idx == -1) {
        } else {
          if (this.sort[idx].key == el) {
            if (this.sort[idx].order == "ASC") order = "DESC";
            if (this.sort[idx].order == "DESC") key = null;
          }
        }
        sort = { key, order };
        this.sort = key ? [sort, ...def] : [...def];
      } else {
        if (this.sort.key == el) {
          if (this.sort.order == "ASC") {
            this.sort.order = "DESC";
          } else {
            this.sort.order = "ASC";
          }
        } else {
          this.sort.key = el;
          this.sort.order = "ASC";
        }
      }
      if (this.useQuery) {
        this.updateUrlParams();
      } else {
        this.updateData();
      }
    },
    updateUrlParams: function () {
      var params = {
        sort: this.sort,
        filters: this.filters,
      };
      this.$router.push({
        query: { [this.urlPrefix]: JSON.stringify(params) },
      });
    },
    onInputFilter: lodash.debounce(function () {
      this.onChangeFilter();
    }, 500),
    onChangeFilter: function () {
      this.pager.page = 0;
      this.pager.count = 0;
      if (this.useQuery) {
        this.updateUrlParams();
      } else {
        this.updateData();
      }
      this.$emit("change-filter", this.filters);
    },
    onScrollEnd(e) {
      if (!this.pager?.count) return;
      let pages = parseInt(this.pager.count / this.pager.limit);
      if (!this.loading && this.maxPage() > this.pager.page) {
        this.pager.page++;
        this.fetchData(true);
      }
    },
    maxPage: function () {
      return Math.ceil(this.pager.count / this.pager.limit);
    },
    async afterFetchData(response) {},
  },
};
</script>
